import { apiService } from "./../../app.service";

export const authApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    resetPassword: builder.mutation({
      query: (data) => ({
        url: "/auth/resetPassword",
        method: "POST",
        body: data,
      }),
    }),

    generateResetPasswordToken: builder.mutation({
      query: (data) => ({
        url: "/auth/generateResetPasswordToken",
        method: "POST",
        body: data,
      }),
    }),

    checkResetPasswordToken: builder.mutation({
      query: (data) => ({
        url: "/auth/checkResetPasswordToken",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useResetPasswordMutation,
  useGenerateResetPasswordTokenMutation,
  useCheckResetPasswordTokenMutation,
} = authApi;
